import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import { IResAgdPledgeListItem } from '@/api/account/interface'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
import classNames from 'classnames'
import AddressHash from '@/components/AddressHash'
import useMeNavigate from '@/hooks/useMeNavigate'
const AgdCard = (props: IResAgdPledgeListItem) => {
  const { t } = useTranslation()
  const amount = ugeaToGea2(props.amount)
  const interestAmount = ugeaToGea2(props.interestAmount)
  const interestAmountGag = ugagToGag(props.interestAmount)
  const navigate = useMeNavigate()
  return (
    <div>
      <div className={styles.wrap}>
        <div
          className={classNames({
            [styles.wrap_item]: true,
            area_a: true,
          })}
        >
          {/* 类型 */}
          <div className={styles.title}>{t('explorer_104')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            {/* 个人权益/灵活期限 */}
            {props.delegationType === 'AGR' ? `${t('explorer_77')}` : t('explorer_75')}
          </div>
        </div>

        <div
          className={classNames({
            [styles.wrap_item]: true,
            area_b: true,
          })}
        >
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <span>{amount.value}</span>{' '}
            <span
              className={classNames({
                [styles.textStyleThree]: true,
                font_14: true,
              })}
            >
              {amount.sigin}
            </span>
          </div>
        </div>
        <div
          className={classNames({
            [styles.wrap_item]: true,
            area_c: true,
          })}
        >
          {/* 上次提取區塊高度 */}
          <div className={styles.title}>{t('explorer_267')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <AddressHash
              data={props.startHeight}
              handleJump={() => {
                navigate(`/blockchain/${props.startHeight}`)
              }}
            />
          </div>
        </div>
        {/* <div
          className={classNames({
            [styles.wrap_item]: true,
            area_c: true,
          })}
        >
          待提取奖励
          <div className={styles.title}>{t('explorer_206')}</div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <span>{interestAmount.value}</span>{' '}
            <span
              className={classNames({
                [styles.textStyleThree]: true,
                font_14: true,
              })}
            >
              {interestAmount.sigin}
            </span>
          </div>
          <div
            className={classNames({
              [styles.textStyleTwo]: true,
              font_14: true,
            })}
          >
            <span>{interestAmountGag.value}</span>{' '}
            <span
              className={classNames({
                [styles.textStyleThree]: true,
                font_14: true,
              })}
            >
              {interestAmountGag.sigin}
            </span>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default AgdCard
